import { TransactionDto } from '@/api/Transaction/Types/Transaction'
import { DataCard, DataColumn, DataGrid } from '@/components/DataCard/DataCard'
import { FormField, FormSelectField } from '@/components/Form/FormField'
import { Button } from '@/components/ui/button'
import { useAppSelector } from '@/store'
import { FormikErrors, FormikProps, withFormik } from 'formik'

export interface AdminPlatformTransferFormValues {
  transactionStateId: {
    id: number
    name: string
  }
  reason: string
  balanceDelta: number
  reservedDelta: number
  pendingDelta: number
}
interface OuterProps {
  transaction: TransactionDto
  onSubmit(values: AdminPlatformTransferFormValues): Promise<void>
  onCancel(): void
}
const AdminPlatformTransferFormUI: React.FC<
  FormikProps<AdminPlatformTransferFormValues> & OuterProps
> = (props) => {
  const { handleSubmit, isSubmitting } = props

  const transactionState = useAppSelector((state) => state.transactions.status)

  const statusOptions = transactionState.map((x) => ({
    id: x.id,
    name: x.name,
  }))

  return (
    <div className='flex overflow-y-auto'>
      <form className='w-full' onSubmit={handleSubmit}>
        <DataGrid columns={2}>
          <DataCard title='Details'>
            <FormSelectField name='transactionStateId' label='Status*' options={statusOptions} />

            <FormField name='reason' label='Reason*' placeholder='Enter reason' />
          </DataCard>

          <DataCard title='Wallet Balance'>
            <FormField name='balanceDelta' label='Balance Delta*' type='number' />

            <FormField name='reservedDelta' label='Reserved Delta*' type='number' />

            <FormField name='pendingDelta' label='Pending Delta*' type='number' />
          </DataCard>

          <DataColumn colSpan={2}>
            <div className='flex justify-center'>
              <Button disabled={isSubmitting} type='submit' className='uppercase px-6'>
                Submit
              </Button>
            </div>
          </DataColumn>
        </DataGrid>
      </form>
    </div>
  )
}
export const AdminPlatformTransferForm = withFormik<OuterProps, AdminPlatformTransferFormValues>({
  mapPropsToValues: ({ transaction }) => ({
    transactionStateId: {
      id: transaction.state.id,
      name: transaction.state.name,
    },
    reason: '',
    balanceDelta: 0,
    reservedDelta: 0,
    pendingDelta: 0,
  }),

  handleSubmit: async (values, { props, setSubmitting }) => {
    await props.onSubmit(values)
    props.onCancel()
    setSubmitting(false)
  },

  validate: (values) => {
    const errors: FormikErrors<AdminPlatformTransferFormValues> = {}

    if (!values.transactionStateId?.id) {
      errors.transactionStateId = { id: 'Required' }
    }

    if (!values.reason) {
      errors.reason = 'Required'
    }

    if (values.balanceDelta === undefined) {
      errors.balanceDelta = 'Required'
    }

    if (values.reservedDelta === undefined) {
      errors.reservedDelta = 'Required'
    }

    if (values.pendingDelta === undefined) {
      errors.pendingDelta = 'Required'
    }

    return errors
  },

  enableReinitialize: true,
})(AdminPlatformTransferFormUI)
